import { t } from '@hefe/i18n';
import { currentUserSelector } from '@hefe/store';
import { Modal } from 'antd';
import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import ClubDataProcessingComponent from '../../containers/club/components/club-data-processing/club-data-processing.component';

export default function DataProcessingAgreementProvider(
  props: PropsWithChildren<any>
) {
  const user = useSelector(currentUserSelector);

  return (
    <div>
      {props.children}
      <Modal
        width={'100%'}
        open={user && user?.hasUnacceptedDPA}
        title={t('data_processing.title')}
        footer={null}
        closeIcon={null}
      >
        <ClubDataProcessingComponent />
      </Modal>
    </div>
  );
}
